import { object, string } from 'yup';

import { validatePhoneNumber } from '@utils/validation';

import { EUserProfileFormValue } from '@enums/userProfile';

import { validationErrMessages } from '@constants/validationConstants';

export const schema = object({
	[EUserProfileFormValue.phoneNumber]: string()
		.trim()
		.default('')
		.required(validationErrMessages.phoneNumber)
		.test('validatePhoneNumber', validationErrMessages.contactNumberFor2Fa, validatePhoneNumber),
});
